import { Platform, View, Text } from 'react-native';
import Head from 'expo-router/head';
import { useRouter } from 'expo-router';
import AnimatedPressable from '@/components/AnimatedPressable';
import {
  FileText,
  Mail,
  Send,
} from 'lucide-react-native';
import Animated, { FadeInDown, FadeInUp } from 'react-native-reanimated';
import { openExternalUrl } from '@/lib/linking';
import { useTrackScreen } from '@/lib/analytics';
import { PublicLayout } from '@/components/PublicLayout';

export default function HelpScreen() {
  useTrackScreen('Help');
  const router = useRouter();

  return (
    <PublicLayout title="Help & Support">
      {Platform.OS === 'web' && (
        <Head>
          <title>Help & Support — Inverio</title>
          <meta name="description" content="Get in touch with the Inverio team. We're here to help." />
          <link rel="canonical" href="https://inverio.ai/help" />
          <meta property="og:title" content="Help & Support — Inverio" />
          <meta property="og:description" content="Get in touch with the Inverio team. We're here to help." />
          <meta property="og:url" content="https://inverio.ai/help" />
        </Head>
      )}

      {/* Contact Us */}
      <Animated.View entering={FadeInDown.delay(100).duration(500)} className="mb-8">
        <Text style={{ color: 'rgba(255,255,255,0.6)' }} className="text-sm font-semibold uppercase tracking-wide mb-3">
          Contact Us
        </Text>
        <View className="flex-row gap-3">
          <AnimatedPressable
            onPress={() => openExternalUrl('mailto:support@inverio.ai', 'Help.email')}
            className="flex-1 p-4 rounded-2xl items-center"
            style={{
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderWidth: 1,
              borderColor: 'rgba(255,255,255,0.08)',
            }}
          >
            <View
              className="w-12 h-12 rounded-full items-center justify-center mb-2"
              style={{ backgroundColor: 'rgba(79,209,197,0.15)' }}
            >
              <Mail size={24} color={'#4fd1c5'} />
            </View>
            <Text style={{ color: '#FFFFFF' }} className="font-semibold">
              Email Us
            </Text>
            <Text style={{ color: 'rgba(255,255,255,0.38)' }} className="text-xs mt-1">
              support@inverio.ai
            </Text>
          </AnimatedPressable>

          <AnimatedPressable
            onPress={() => router.push('/contact')}
            className="flex-1 p-4 rounded-2xl items-center"
            style={{
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderWidth: 1,
              borderColor: 'rgba(255,255,255,0.08)',
            }}
          >
            <View
              className="w-12 h-12 rounded-full items-center justify-center mb-2"
              style={{ backgroundColor: 'rgba(79,209,197,0.15)' }}
            >
              <FileText size={24} color={'#4fd1c5'} />
            </View>
            <Text style={{ color: '#FFFFFF' }} className="font-semibold">
              Contact Page
            </Text>
            <Text style={{ color: 'rgba(255,255,255,0.38)' }} className="text-xs mt-1">
              Form & all channels
            </Text>
          </AnimatedPressable>
        </View>
      </Animated.View>

      {/* Send a Message CTA */}
      <Animated.View entering={FadeInUp.delay(200).duration(500)}>
        <View
          className="p-6 rounded-2xl"
          style={{
            backgroundColor: 'rgba(79,209,197,0.15)',
            borderWidth: 1,
            borderColor: 'rgba(79,209,197,0.15)',
          }}
        >
          <Text style={{ color: '#4fd1c5' }} className="text-lg font-semibold mb-2">
            Have a question?
          </Text>
          <Text style={{ color: 'rgba(255,255,255,0.6)' }} className="text-sm mb-4">
            Our support team typically responds within 24 hours.
          </Text>
          <AnimatedPressable
            onPress={() => router.push('/contact')}
            className="flex-row items-center justify-center gap-2 py-3 rounded-xl"
            style={{ backgroundColor: '#4fd1c5' }}
          >
            <Send size={18} color="white" />
            <Text className="text-white font-semibold">Send a Message</Text>
          </AnimatedPressable>
        </View>
      </Animated.View>
    </PublicLayout>
  );
}
